import * as client from '../../services/client';
import { TYPES } from '../../common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { store } from '..';
export const onFetchOnboardingOrders = (propertyId, suiteId, userId) => dispatch => {
    dispatch({
        type : TYPES.FETCH_ORDERS_LOADING,
        payload: true
    })
    return client.fetchOnboardingOrders(propertyId).then(response => {
        dispatch({
            type : TYPES.FETCH_ORDERS_LOADING,
            payload: false
        })
        if(response.status === 200) {
            response.json().then(responseJson => {
                if(responseJson && responseJson.data && responseJson.data.length > 0) {
                    let suiteStatus=store.getState().userSuites.selectedUserSuite.status;
                    let filteredOrderPostOccupied = Object.keys(responseJson.data).length > 0? responseJson.data.filter((order) => order.isPostOccupancy === true):{}
                    let filteredOrderPreOccupied = Object.keys(responseJson.data).length > 0? responseJson.data.filter((order) => order.isPostOccupancy === false):{}
                     const filterOrderData = suiteStatus ==="Occupied"? filteredOrderPostOccupied:filteredOrderPreOccupied;
               
                    dispatch({
                        type : TYPES.FETCH_ONBOARDING_ORDERS,
                        payload: filterOrderData
                    })    
                    if(Object.keys(filterOrderData).length >0){
                        dispatch(fetchOnboardingOrderDetails(filterOrderData[0].propertyId, filterOrderData[0].id, suiteId, userId))
                        dispatch(saveOrderId(filterOrderData[0].id))
                    }                
                } else {
                    dispatch({
                        type : TYPES.FETCH_ONBOARDING_ORDERS,
                        payload: []
                    }) 
                }   
            })
        } else {
            toast.error( ' 🚫 Something went wrong with fetching orders, please try again.',{autoClose:12000,position:'top-center'})
        }
    })
    .catch(() => {
        dispatch({
            type : TYPES.FETCH_ORDERS_LOADING,
            payload: false
        })
        toast.error( ' 🚫 Something went wrong with fetching orders, please try again.',{autoClose:12000,position:'top-center'})
    })
}

export const saveOrderId = (orderId) => dispatch => {
    dispatch({
        type : TYPES.SAVE_ONBOARDING_ORDER_ID,
        payload: orderId
    }) 
}

export const fetchOnboardingOrderDetails = (propertyId, orderId, suiteId, userId) => dispatch => {
    dispatch(startOnboardingLoader())
    return client.fetchOnboardingOrderDetails(propertyId, orderId, suiteId, userId).then(response => {
        if(response.status === 200) {
            response.json().then(responseJson => {                
                if(responseJson && responseJson.data && responseJson.data.id) {
                    dispatch({
                        type : TYPES.FETCH_ONBOARDING_ORDER_DETAILS,
                        payload: responseJson.data
                    })
                    dispatch({
                        type : TYPES.FETCH_CONVEYANCE_FORM_DATA,
                        payload: responseJson.data.suiteOnBoardingConveyanceForm || {
                            email:'',
                            fax:'',
                            financialInstitutionBank:'',
                            homeOwner:'',
                            id:'',
                            lawFirmNotary:'',
                            lawyerNotaryContactName:'',
                            mailingAddress:'',
                            phone:'',
                            propertyName:'',
                            stratalot:'',
                            suiteName:'',
                        }
                    })
                    dispatch(stopOnboardingLoader())
                } else {
                    dispatch(fetchOrderDetailsDone()) 
                }   
            })
        } else {
            dispatch(fetchOrderDetailsDone()) 
            toast.error( ' 🚫 Something went wrong with fetching order details, please try again.',{autoClose:12000,position:'top-center'})
        }
    })
    .catch(() => {
        dispatch(fetchOrderDetailsDone()) 
        dispatch(stopOnboardingLoader())
        toast.error( ' 🚫 Something went wrong with order details, please try again.',{autoClose:12000,position:'top-center'})
    })
}

export const fetchOrderDetailsDone = () =>  dispatch => {
    dispatch({
        type : TYPES.FETCH_ONBOARDING_ORDER_DETAILS,
        payload: {}
    }) 
}
export const clearOrderDetails = () => dispatch => {
    dispatch({
        type : TYPES.CLEAR_FETCH_ONBOARDING_ORDER_DETAILS
    }) 
}
export const clearSaveConveyanceFormData = () => dispatch => {
    dispatch({
        type : TYPES.FETCH_CONVEYANCE_FORM_DATA,
        payload:{
            email:'',
            fax:'',
            financialInstitutionBank:'',
            homeOwner:'',
            id:'',
            lawFirmNotary:'',
            lawyerNotaryContactName:'',
            mailingAddress:'',
            phone:'',
            propertyName:'',
            stratalot:'',
            suiteName:'',
        }
    }) 
}
export const clearOrders = () => dispatch => {
    dispatch({
        type : TYPES.CLEAR_FETCH_ONBOARDING_ORDERS
    }) 
}
export const startOnboardingLoader = () => dispatch => {
    dispatch({
        type : TYPES.FETCH_ONBOARDING_ORDER_DETAILS_LOADING,
        payload: true
    })
}
export const stopOnboardingLoader = () => dispatch => {
    dispatch({
        type : TYPES.FETCH_ONBOARDING_ORDER_DETAILS_LOADING,
        payload: false
    })
}

export const onChangeChecklistStatus = (params) => dispatch => {
    dispatch(startOnboardingLoader())
    return client.onChangeChecklistStatus(params).then(response => {
       dispatch(stopOnboardingLoader())
        if(response.status === 200) {
            response.json().then(responseJson => {  
                if(responseJson && responseJson.statusCode === 200) {
                    dispatch({
                        type : TYPES.SET_ONBOARDING_ORDER_CHECKLISTDETAILS,
                        payload: params.suiteOnBoardingChecklist[0]
                    })
                } else {
                    toast.error( ' 🚫 Checklist saving failed, please try again.',{autoClose:12000,position:'top-center'})
                }   
            })
        } else {
           toast.error( ' 🚫 Something went wrong with checklist saving, please try again.',{autoClose:12000,position:'top-center'})
        }
    })
    .catch(() => {
        dispatch(stopOnboardingLoader())
       toast.error( ' 🚫 Something went wrong with checklist saving, please try again.',{autoClose:12000,position:'top-center'})
    })
}

export const onAddChecklistNote = (params) => dispatch => {    
    dispatch(startOnboardingLoader())
    return client.onAddChecklistNote(params).then(response => {
       dispatch(stopOnboardingLoader())
        if(response.status === 200) {
            response.json().then(responseJson => {  
                if(responseJson && responseJson.statusCode === 200) {
                    dispatch({
                        type : TYPES.SET_ONBOARDING_ORDER_CHECKLIST_NOTES,
                        payload: {notes : responseJson.data, checklistId : params.checklistId}
                    })
                    toast.success( ' ⓘ Note added successfully,',{autoClose:12000,position:'top-center'})
                } else {
                    toast.error( ' 🚫 Note adding failed.',{autoClose:12000,position:'top-center'})
                }   
            })
        } else {
           toast.error( ' 🚫 Something went wrong with adding note, please try again.',{autoClose:12000,position:'top-center'})
        }
    })
    .catch(() => {
        dispatch(stopOnboardingLoader())
       toast.error( ' 🚫 Something went wrong with adding note, please try again.',{autoClose:12000,position:'top-center'})
    })
}

export const onUpdateChecklistNote = (params) => dispatch => {    
    dispatch(startOnboardingLoader())
    return client.onUpdateChecklistNote(params).then(response => {
       dispatch(stopOnboardingLoader())
        if(response.status === 200) {
            response.json().then(responseJson => {                  
                if(responseJson && responseJson.statusCode === 200) {
                    dispatch({
                        type : TYPES.SET_ONBOARDING_ORDER_CHECKLIST_NOTES,
                        payload: {notes : responseJson.data, checklistId : params.checklistId}
                    })
                    toast.success( ' ⓘ Note updated successfully,',{autoClose:12000,position:'top-center'})
                } else {
                    toast.error( ' 🚫 Note updating failed.',{autoClose:12000,position:'top-center'})
                }   
            })
        } else {
           toast.error( ' 🚫 Something went wrong with updating note, please try again.',{autoClose:12000,position:'top-center'})
        }
    })
    .catch(() => {
        dispatch(stopOnboardingLoader())
       toast.error( ' 🚫 Something went wrong with updating note, please try again.',{autoClose:12000,position:'top-center'})
    })
}
export const onAddChecklistDocument = (params, type) => dispatch => {    
    dispatch(startOnboardingLoader())
    return client.onAddChecklistDocument(params).then(response => {
       dispatch(stopOnboardingLoader())
        if(response.status === 200) {
            response.json().then(responseJson => {  
                if(responseJson && responseJson.statusCode === 200) {
                    if(type === 'delete') {
                        dispatch({
                            type : TYPES.DELETE_ONBOARDING_ORDER_CHECKLIST_DOCUMENTS,
                            payload: {documents : responseJson.data, checklistId : params.checklistId}
                        })
                    } else {
                        dispatch({
                            type : TYPES.SET_ONBOARDING_ORDER_CHECKLIST_DOCUMENTS,
                            payload: {documents : responseJson.data, checklistId : params.checklistId}
                        })
                    }
                   
                    toast.success( ` ⓘ Documents ${type === 'delete' ? 'deleted' : 'added'} successfully,`,{autoClose:12000,position:'top-center'})
                } else {
                    toast.error( ` 🚫 Documents ${type === 'delete' ? 'deleting' : 'adding'} failed.`,{autoClose:12000,position:'top-center'})
                }   
            })
        } else {
           toast.error( ` 🚫 Something went wrong with ${type === 'delete' ? 'deleting' : 'adding'} documents, please try again.`,{autoClose:12000,position:'top-center'})
        }
    })
    .catch(() => {
        dispatch(stopOnboardingLoader())
        toast.error( ` 🚫 Something went wrong with ${type === 'delete' ? 'deleting' : 'adding'} documents, please try again.`,{autoClose:12000,position:'top-center'})
    })
}

export const saveNotaryForm = (params) => dispatch => {  
    dispatch(startOnboardingLoader())   
    return client.saveNotaryForm(params).then(response => {
      if(response.ok || response.status === 200) {
        response.json().then(
          responsejson => {
            if(responsejson && responsejson.statusCode === 200) {
                dispatch({
                    type : TYPES.FETCH_CONVEYANCE_FORM,
                    payload:params
                })
               
                dispatch({
                    type : TYPES.FETCH_CONVEYANCE_FORM_DATA,
                    payload: responsejson.data || {
                        email:'',
                        fax:'',
                        financialInstitutionBank:'',
                        homeOwner:'',
                        id:'',
                        lawFirmNotary:'',
                        lawyerNotaryContactName:'',
                        mailingAddress:'',
                        phone:'',
                        propertyName:'',
                        stratalot:'',
                        suiteName:'',
                    }
                })
                dispatch(stopOnboardingLoader())
              toast.success(` ⓘ Conveyance Form ${params && params.id ? 'updated' : 'saved'} successfully.`,{autoClose:10000,position:'top-center'})
            } else {
              toast.error(`🚫 Conveyance Form ${params && params.id ? 'updating' : 'saving'} failed, please try again.`,{autoClose:12000,position:'top-center'})
            }
          })
      } else {
        toast.error(`🚫 Conveyance Form ${params && params.id ? 'updating' : 'saving'} failed, please try again.`,{autoClose:12000,position:'top-center'})
    }
    })
    .catch(() => {
        toast.error(`🚫 Something went wrong with ${params && params.id ? 'updating' : 'saving'} failed, please try again.`,{autoClose:12000,position:'top-center'})
   })
   }

   export const clearConveyanceForm = () => dispatch => {
    dispatch({
        type : TYPES.CLEAR_CONVEYANCE_FORM
    }) 
}